const DECIMAL_COUNT = 2;
export function getPriceSuffix(type) {
    switch (type) {
        case "initial":
            return "for første utsendelse";
        case "yearly":
            return "per år";
        case "per book":
            return "per bok";
        default:
            return null;
    }
}
export function formatPrice(price, type = "single") {
    if (typeof price !== "number")
        return "-";
    if (Number.isNaN(price))
        return "";
    // Check if the price, rounded to two decimals, is an integer
    const priceRoundedString = price.toFixed(DECIMAL_COUNT);
    const priceRounded = Number(priceRoundedString);
    let finalPrice;
    if (Number.isInteger(priceRounded)) {
        finalPrice = `${priceRounded},-`;
    }
    else {
        finalPrice = priceRoundedString.replace(".", ",");
    }
    finalPrice = insertSpacesInPrice(finalPrice);
    return [finalPrice, getPriceSuffix(type)].filter(Boolean).join(" ");
}
export function insertSpacesInPrice(price) {
    return price.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
